import Box from "@mui/material/Box";
import { useCallback, useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import AlertMessages from "common/Alert/AlertMessages";
import { useTranslation } from "react-i18next";
import Loader from "layout/Loader";
import BackendPaginationTable from "common/Table/TableWithPagination";
import ComponentHeaderTwo from "common/ComponentHeaderTwo/ComponentHeaderTwo";
import MoveDownOutlinedIcon from "@mui/icons-material/MoveDownOutlined";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import StyledInput from "common/SearchField/Search";
import { useGetAccountTransfersService } from "subModule/src/services/bankaccount/useBankAccount";
import { selectUserInfo } from "features/user/userSlice";
import { useSelector } from "react-redux";

export default function InterAccountTransferListing() {
  const navigate = useNavigate();
  const loggedInUserCurrency = useSelector(selectUserInfo)?.business?.currency;
  const [pageNo, setPageNo] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(20);
  const [searchTerm, setSearchTerm] = useState<any>("");
  const [search, setSearch] = useState("");
  const {
    data: tableData,
    isFetching,
    refetch,
  } = searchTerm
    ? useGetAccountTransfersService({
        pageNumber: pageNo,
        size: pageSize,
        accountName: searchTerm,
      })
    : useGetAccountTransfersService({ pageNumber: pageNo, size: pageSize });
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const fetchData = useCallback(() => {
    refetch().then((res: any) => {
      if (!res?.data?.pages[0]?.success)
        enqueueSnackbar(
          <AlertMessages
            text={res?.data?.pages[0]?.message || "Something went wrong"}
          />,
          { variant: "error" },
        );
    });
  }, []);
  useEffect(() => {
    fetchData();
  }, [pageNo, pageSize, searchTerm]);
  const handleChangePage = (pageNo: number) => {
    setPageNo(pageNo + 1);
  };
  const handleChangeRows = (pageSize: number) => {
    setPageSize(pageSize);
    setPageNo(1);
  };
  const clearSearch = () => {
    setSearch("");
    setSearchTerm("");
    if (searchTerm) handleSearch("");
  };
  const handleSearch = (search: string) => {
    setSearchTerm(search);
    setPageNo(1);
    setPageSize(pageSize);
  };
  const handleSearchClick = () => {
    const trimmedSearch = search.trim();
    if (trimmedSearch !== "") {
      handleSearch(trimmedSearch);
    }
  };
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value.trim());
    if (!event.target.value.trim()) handleSearch("");
  };

  return (
    <Box>
      <ComponentHeaderTwo
        showBtn={true}
        showSaveBtn={false}
        onClick={() => navigate("/inter-account-transfer/create")}
        heading={t("interAccountTransfers")}
        icon={
          <MoveDownOutlinedIcon
            sx={{
              fill: "#000",
              width: "30px",
              height: "30px",
              marginTop: "3px",
            }}
          />
        }
        btnText={"create"}
        btnType={"create"}
        showCreateBtn={true}
      />
      <Box>
        {isFetching ? (
          <Loader />
        ) : (
          <div id="mainListingTable">
            <BackendPaginationTable
              columns={[
                {
                  id: "fromAccountTitle",
                  label: t("from") + " " + t("ACCOUNT"),
                  numeric: false,
                  width: "22%",
                },
                {
                  id: "toAccountTitle",
                  label: t("to") + " " + t("ACCOUNT"),
                  numeric: false,
                  width: "22%",
                },
                {
                  id: "transferNo",
                  label: t("transferNo"),
                  numeric: false,
                  width: "16%",
                },
                {
                  id: "amountAccount",
                  label: "amount",
                  numeric: false,
                  width: "14%",
                },
                {
                  id: "createdAt",
                  label: "createdAt",
                  numeric: false,
                  width: "20%",
                },
              ]}
              data={tableData?.pages[0]?.data?.content || []}
              pageNo={pageNo}
              pageSize={pageSize}
              tableData={tableData?.pages[0]?.data || {}}
              showCheckbox={false}
              showActions={true}
              enableSorting={true}
              showHeader={true}
              showSearch={true}
              showFilter={true}
              showCreateButton={true}
              handleChangePage={handleChangePage}
              handleChangeRows={handleChangeRows}
              rowClick={true}
              showRowView={() => {}}
              loadingSearch={false}
              currency={loggedInUserCurrency}
              headerComponent={
                <StyledInput
                  // fullWidth
                  placeholder={t("ACCOUNT")}
                  handleSearchClick={handleSearchClick}
                  handleChange={handleInputChange}
                  value={search}
                  clearSearch={clearSearch}
                />
              }
            />
          </div>
        )}
      </Box>
    </Box>
  );
}
